<template>
  <div class="chatWoot-content"
       @click="customerClick">
    <img src="../icon/chatWoot.png">
  </div>
</template>
<script setup lang="ts">
import { useChatWoot } from "@huntersofbook/chatwoot-vue"
const { toggle, setLabel } = useChatWoot()

const customerClick = () => {
  toggle("open")
  setLabel("name")
}
</script>

<style scoped lang="less">
.chatWoot-content {
  height: 100%;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 14px 28px 0px rgba(0, 0, 0, 0.16);
  border-radius: 50%;
  display: flex;
  align-items: center;
  align-content: stretch;
  justify-content: space-around;
  cursor: pointer;
  -webkit-user-select: none;
  /* 针对Chrome/Safari/Opera */
  -moz-user-select: none;
  /* 针对Firefox */
  -ms-user-select: none;
  /* 针对IE10+ */
  user-select: none;

  img {
    width: 23px;
    height: 24px;
  }
}

.chatWoot-content:hover{
  box-shadow:  0px 14px 28px 10px rgba(0, 0, 0, 0.16);
}

</style>
